import { getSportConfig, SPORT_ID } from '@/config/sports'

export const CARD_SWATCHES: Record<string, string> = {
  yellow: '#F5C400',
  red: '#D62828',
  green: '#2E9E44',
}

export const resolveCardColors = (sportId: SPORT_ID | undefined): string[] => {
  const cfg = getSportConfig(sportId ?? SPORT_ID.SOCCER)
  return (cfg?.disciplinary ?? ['yellow', 'red']).filter((c) => c in CARD_SWATCHES)
}

export const totalCardCount = (cards: Record<string, number> | undefined, cardColors: string[]): number =>
  cardColors.reduce((sum, c) => sum + (cards?.[c] ?? 0), 0)
